export default __webpack_public_path__ + "static/media/keyvis_players_dt_names.52fab899.png";